var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('b-navbar',{staticClass:"minimal-nav d-flex justify-content-center align-items-center"},[_c('b-navbar-brand',{staticClass:"m-0",attrs:{"to":{ name: 'Dashboard' }}},[(_vm.companyLogo)?_c('img',{attrs:{"src":_vm.companyLogo}}):_c('h2',[_vm._v(_vm._s(_vm.companyName))])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9d00a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header-minimal.vue
// module id = LI98
// module chunks = 0